(() => {
  const mounted = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    const sections = [...root.querySelectorAll('[data-pdp-section]')];
    if (root.matches?.('[data-pdp-section]')) sections.push(root);
    sections.forEach(section => {
      if (mounted.has(section)) return;
      const controller = new AbortController();
      const {signal} = controller;
      const track = section.querySelector('.pdp-gallery-track');
      const frames = [...section.querySelectorAll('.pdp-gallery-frame')];
      const thumbs = [...section.querySelectorAll('[data-pdp-thumb]')];
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {
        if (!track || !frames[index]) return;
        event.preventDefault();
        track.scrollTo({left:frames[index].offsetLeft - frames[0].offsetLeft, behavior:reduced.matches?'instant':'smooth'});
      }, {signal}));
      const observer = track ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio < .6) return;
          const index = frames.indexOf(entry.target);
          thumbs.forEach((thumb, i) => i === index ? thumb.setAttribute('aria-current','true') : thumb.removeAttribute('aria-current'));
          frames.forEach(frame => {if (frame !== entry.target) frame.querySelector('video')?.pause();});
        });
      }, {root:track,threshold:.6}) : null;
      frames.forEach(frame => observer?.observe(frame));
      const form = section.querySelector('.pdp-purchase-form');
      const mobile = section.querySelector('[data-pdp-mobile-buy]');
      const buyObserver = form && mobile ? new IntersectionObserver(entries => {
        const entry = entries[0];
        // Show the compact purchase bar only after the main form scrolls above view.
        mobile.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
      },{threshold:0}) : null;
      if (form) buyObserver?.observe(form);
      mounted.set(section,()=>{controller.abort();observer?.disconnect();buyObserver?.disconnect();if(mobile)mobile.hidden=true;mounted.delete(section);});
    });
  }
  function unmount(root) {
    root.querySelectorAll('[data-pdp-section]').forEach(section => mounted.get(section)?.());
    mounted.get(root)?.();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
  else mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>unmount(event.target));
})();
